<template>
  <div id="userInfo" class="clearfix">
    <van-cell-group>
      <van-cell title="头像">
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #right-icon>
          <van-image
              round
              fit="contain"
              :src="user.uuid?getAvatarByUUID(user.uuid):''"
          />
        </template>
      </van-cell>
      <van-cell center title="姓名" :value="user.userName" @click="clicksHandle"></van-cell>
      <van-cell center title="所属部门" :value="user.unitName"></van-cell>
      <van-cell center title="手机号" :value="user.telMobile1"></van-cell>
      <van-cell center title="办公电话" :value="user.telOffice"></van-cell>
      <van-cell center title="邮箱" :value="user.email"></van-cell>
    </van-cell-group>
  </div>
</template>

<script>
import {CellGroup,Cell,Image} from 'vant'
import {queryUserLogin} from "@/api";
import {getAvatarByUUID} from "@/utils/commons";
import {locationTo} from "@/utils/url";
export default {
  components:{
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Image.name]:Image
  },
  data() {
    return {
      user: {},
      clicks:0,
      timer:null
    }
  },
  created() {
    this.$store.commit("toggleTabbarShow", false);
    this.init()
  },
  beforeDestroy() {
    this.$store.commit("toggleTabbarShow", true);
    this.clearTimer();
  },
  methods: {
    init() {
      if (sessionStorage.getItem("current-login-user")) {
        this.user = JSON.parse(sessionStorage.getItem("current-login-user"));
      } else {
        this.refreshUser();
      }
    },
    refreshUser(){
      queryUserLogin().then(user=>{
        if(user.data){
          this.user = user.data;
          sessionStorage.setItem("current-login-user",JSON.stringify(user.data));
        }
      });
    },
    clicksHandle(){
      if(!this.user.userName){
        return;
      }
      if(this.clicks>=5){
        locationTo('weixin/weui/debug.html');
      }else{
        this.clicks++;
      }
      if(this.timer === null){
        this.timer = setInterval(()=>{
          if(this.clicks<=0){
            this.timer && this.clearTimer();
          }else{
            this.clicks--;
          }
        },400);
      }
    },
    clearTimer(){
      clearInterval(this.timer);
      this.timer = null;
      this.clicks=0;
    },
    getAvatarByUUID
  }
}
</script>

<style lang="scss">
@import "~@/assets/css/theme/theme.scss";
#userInfo{
  .van-cell-group{
    margin-top: 15px;
    .van-cell{
      min-height: 55px;
      line-height: 45px;
      padding-top: 5px;
      padding-bottom: 5px;
      @extend .font16;
      .van-image{
        width: 45px;
        height: 45px;
      }
      .van-cell__title {
        width: 30%;
      }
      .van-cell__value {
        width: 70%;
        line-height: 24px;
        flex: 1 1 50%;
      }
    }
    &:after{
      display: none;
    }
  }
}
</style>
